var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p> <b>Ваше письмо отправлено!</b> </p> <p> Очень скоро наши специалисты свяжутся с Вами. Спасибо за ожидание. </p>';
}
return __p;
};
